import axios from 'axios'; // Import Axios library
import {toast} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import router from "../../router";

// Featured businesses shipped by LandingController (window.__BOOT__) on the
// server-rendered home page, so the featured carousel renders immediately with no
// shimmer/refetch. Empty elsewhere.
const boot = (typeof window !== 'undefined' && window.__BOOT__) || {};

const businessModule = {
    namespaced: true,
    state() {
        return {
            Gallery: [],
            GalleryLoading: false,
            reviews: [],
            reviewLoading: true,
            countries: [],
            products: [],
            productloading: false,
            productCategories: [],
            pagination: null,
            product_total_result: 0,
            country: [],
            countryLoading: false,
            category: [],
            subCategory: [],
            selectedCategoryId: null,
            cartItems: null,
            addToCartButtonLoading: false,
            single_businesses_loading: true,
            businesses: [],
            businesses_loading: false,
            SubCategory: [],
            SubCategory_loading: false,
            city: [],
            cityLoading: false,
            Amenities: [],
            amenitiesLoading:false,
            favouriteLoading: false,
            favourite: [],
            favouriteProductAllLoading: false,
            featured_businessess: boot.featured || [],
            featured_businessess_loading: boot.featured ? false : true,
            business: [],
            quantities: [], // Use an array to hold quantities for multiple products
            IsFavourite : false, // for business cart heart icon
            FavItemsCount:0,
            reviewLoader:false
        };
    },
    mutations: {
        SET_FEATURED_BUSINESS(state, data){
            state.featured_businessess = data
        },
        SET_FEATURED_BUSINESS_LOADING(state, data){
            state.featured_businessess_loading = data
        },
        SET_AMENITIES(state, data){
            state.Amenities = data
        },
        SET_AMENITIES_LOADING(state, loading){
            state.amenitiesLoading = loading
        },
        SET_CITY(state, data){
          state.city = data
        },
        APPEND_CITY(state, cities) {
            state.city = [...state.city, ...cities];
        },
        SET_CITY_LOADING(state, loading){
            state.cityLoading = loading
        },
        SET_SUBCATEGORY(state, data){
            state.SubCategory = data
        },
        SET_SUBCATEGORY_LOADING(state, loading){
            state.SubCategory_loading = loading
        },
        SET_PAGINATION(state, page) {
            state.pagination = page
        },
        SET_PRODUCT_TOTAL_RESULT(state, data) {
            state.product_total_result = data;
        },
        SET_BUSINESS(state, data) {
            state.businesses = data
        },
        SET_BUSINESS_LOADING(state, loading) {
            state.businesses_loading = loading
        },

        SET_ADD_TO_CART_BUTTON_LOADING(state, loading) {
            state.addToCartButtonLoading = loading
        },
        SET_GALLERY_DATA(state, data) {
            state.Gallery = data;
        },
        SET_GALLERY_DATA_LOADING(state, loading) {
            state.GalleryLoading = loading;
        },
        SET_GALLERY_LOADING(state, loading) {
            state.GalleryLoading = loading;
        },
        SET_REVIEW_DATA(state, data) {
            state.reviews = data;
        },
        SET_REVIEW_LOADING(state, loading) {
            state.reviewLoading = loading;
        },
        SET_COUNTRY_DATA(state, data) {
            state.country = data
        },
        SET_COUNTRY_LOADING(state, loading) {
            state.countryLoading = loading;
        },
        SET_PRODUCT_DATA(state, data) {
            state.products = data
        },
        SET_PRODUCT_SHIMMER(state, loading) {
            state.productloading = loading
        },
        SET_PRODUCT_CATEGORY_DATA(state, data) {
            state.productCategories = data
        },
        SET_CATEGORIES_DATA(state, data) {
            state.category = data;
        },
        SET_SUBCATEGORIES_DATA(state, data) {
            state.subCategory = data;
        },
        SET_SELECTED_CATEGORY(state, data) {
            state.selectedCategoryId = data;
        },
        CLEAR_SELECTED_CATEGORY(state) {
            state.selectedCategoryId = null;
        },
        INCREMENT_PRODUCT_QUANTITY(state, index) {
            if (state.quantities[index] === undefined) {
                state.quantities[index] = 1; // Initialize if it's undefined
            }
            state.quantities[index]++;
        },

        DECREMENT_PRODUCT_QUANTITY(state, index) {
            if (state.quantities[index] > 1) {
                state.quantities[index]--;
            }
        },
        INCREMENT_PRODUCT_QUANTITY_FROM_CART(state, index) {
            state.cartItems.items[index].quantity++;
        },
        DECREMENT_PRODUCT_QUANTITY_FROM_CART(state, index) {
            if (state.cartItems.items[index].quantity > 1) {
                state.cartItems.items[index].quantity--;
            }
        },
        INCREMENT_SINGLE_PRODUCT_QUANTITY(state) {
            state.singleProduct.quantity++;
        },
        DECREMENT_SINGLE_PRODUCT_QUANTITY(state) {
            if (state.singleProduct.quantity > 1) {
                state.singleProduct.quantity--;
            }
        },
        SET_PAGINATION_CURRENTPAGE(state, page) {
            state.paginationCurrentPage = page;
        },
        SET_PAGINATION_TOTALPAGE(state, totalPages) {
            state.paginationTotalPages = totalPages;
        },
        SET_CART_ITEMS(state, loading) {
            state.cartItems = loading
        },
        SET_SINGLE_BUSINESS(state, loading) {
            state.business = loading
        },
        SET_SINGLE_BUSINESS_LOADING(state, loading) {
            state.single_businesses_loading = loading
        },
        SET_favourite_DATA(state, data){
            state.favourite = data
        },
        SET_FAVOURITE_DATA_LOADING(state, loading){
            state.favouriteLoading = loading
        },
        SET_FAVOURITE_DATA_all_LOADING(state, loading){
            state.favouriteProductAllLoading = loading
        },
        SET_IS_FAVOURITE(state, loading){
            state.IsFavourite = loading
        },
        SET_FAV_COUNT(state,count){
            state.FavItemsCount = count
        },
        INCREMENT_FAV_ITEMS_COUNT(state) {
            state.FavItemsCount += 1;
        },
        DECREMENT_FAV_ITEMS_COUNT(state) {
            state.FavItemsCount -= 1;
        },
        SET_BUSINESS_REVIEW_LOADER(state ,loading){
            state.reviewLoader = loading;
        }
    },
    actions: {
        // async fetchBusinessSerach({ commit }, { business_name, country_id, which }) {
        //     try {
        //         console.log({ business_name, country_id, which }); // Debugging step
        //         const response = await axios.post('/api/business/search', {
        //             business_name: business_name,
        //             country_id: country_id,
        //             which: which,
        //         });
        //         commit('SET_FEATURED_BUSINESS', response.data.data);
        //     } catch (error) {
        //         console.log('Error fetching featured businesses:', error);
        //     }
        // },

        async featuredBusinesses({ commit }) {
            try {
                commit('SET_FEATURED_BUSINESS_LOADING', true);

                const token = localStorage.getItem('token'); // Check if the token exists
                let updatedBusinesses = [];

                const response = await axios.get('/api/featured-businesses');

                // Get featured businesses from the response
                const featuredBusinesses = Array.isArray(response.data.businesses)
                    ? response.data.businesses
                    : [];

                // Get favorite businesses if available
                const favoriteBusinesses = Array.isArray(response.data.favorite_businesses)
                    ? response.data.favorite_businesses
                    : [];

                if (token && favoriteBusinesses.length > 0) {
                    // Mark businesses as favorite if they are in the favorites list
                    updatedBusinesses = featuredBusinesses.map(business => {
                        const isFavorite = favoriteBusinesses.some(fav => fav.id === business.id);
                        return { ...business, is_favorite: isFavorite };
                    });

                    // Check if there are any favorite businesses in the featured list
                    const hasFavorites = updatedBusinesses.some(business => business.is_favorite);
                    commit('SET_IS_FAVOURITE', hasFavorites);
                } else {
                    // If user is not logged in or no favorites exist, set all businesses as not favorite
                    updatedBusinesses = featuredBusinesses.map(business => ({
                        ...business,
                        is_favorite: false,
                    }));

                    commit('SET_IS_FAVOURITE', false); // No favorites for non-logged-in users
                }

                // Commit the updated businesses to the store
                commit('SET_FEATURED_BUSINESS', updatedBusinesses);
                commit('SET_FEATURED_BUSINESS_LOADING', false);
            } catch (error) {
                commit('SET_FEATURED_BUSINESS_LOADING', false);
                console.error('Error fetching featured businesses:', error);
            }
        },
        async fetchFavouriteProductAll({ commit }) {
            const token = localStorage.getItem('token'); // Get the token from localStorage

            // Check if the token exists
            if (!token) {
                console.log("User is not logged in. Skipping favorite fetch.");
                commit('SET_FAVOURITE_DATA_all_LOADING', false); // Ensure the loading state is cleared
                commit('SET_favourite_DATA', []); // Clear favorite data
                commit('SET_IS_FAVOURITE', false); // Set no favorites
                return; // Exit the function early
            }

            let url = `/api/favourites`; // This endpoint only returns favorite businesses
            try {
                commit('SET_FAVOURITE_DATA_all_LOADING', true);

                // Fetch the favorite businesses
                let response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                // Since all businesses fetched from this API are favorites, we directly mark them
                const favoriteBusinesses = response.data.map(business => {
                    return { ...business, is_favorite: true }; // All businesses are favorites
                });

                // Commit the favorite businesses to the state
                commit('SET_favourite_DATA', favoriteBusinesses);

                // Check if there are any favorites in the fetched list
                const hasFavorites = favoriteBusinesses.length > 0;
                commit('SET_IS_FAVOURITE', hasFavorites);

                commit('SET_FAVOURITE_DATA_all_LOADING', false);
            } catch (error) {
                console.log(error);
                commit('SET_FAVOURITE_DATA_all_LOADING', false);
            }
        },

        async fetchFavouriteProduct({ commit }, { business_id }) {
            const token = localStorage.getItem('token');
            let url = `/api/add/to/favourite/${business_id}`;
            try {
                commit('SET_FAVOURITE_DATA_LOADING', true);  // Start global loader
                let response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                commit('SET_FAVOURITE_DATA_LOADING', false); // Stop loader after response

                if (response.data.success === 'Like Done' || response.data.success === 'Unlike') {
                    return response.data;  // Success response
                } else {
                    // Handle unexpected response
                    throw new Error('Unexpected response from the server');
                }
            } catch (error) {
                console.log(error);
                commit('SET_FAVOURITE_DATA_LOADING', false);  // Stop loader on error
                throw error;  // Propagate error to be handled in the component
            }
        },

        async fetchFavItemCount({commit}) {
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('User not logged in');
                // toast.error("User no logged in");
                return;
            }

            try {
                const response = await axios.get('/api/favourite-item-count', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                // console.log(response.data);
                commit('SET_FAV_COUNT' ,response.data.count)
            } catch (error) {
                console.error('Error fetching favorite count:', error);
            }
        },

        // favitemcount Increment or Decrment function

        incrementFavItemsCount({ commit }) {
            commit('INCREMENT_FAV_ITEMS_COUNT');
        },
        decrementFavItemsCount({ commit }) {
            commit('DECREMENT_FAV_ITEMS_COUNT');
        },


        async fetchBusinessAmenities({commit}){
            const url = `/api/amenities`;

            try{
                commit('SET_AMENITIES_LOADING', true)
                let response = await axios.get(url)
                commit('SET_AMENITIES', response.data)
                commit('SET_AMENITIES_LOADING', false)
            } catch(error){
                console.log('error', error)
                commit('SET_AMENITIES_LOADING', false)
            }
        },

        async fetchSingleBusiness({commit, state}, business_id) {
            commit('SET_SINGLE_BUSINESS_LOADING', true);
            try {
                const response = await axios.get(`/api/single/business/${business_id}`);
                console.log(response.data);
                commit('SET_SINGLE_BUSINESS', response.data);
                commit('SET_SINGLE_BUSINESS_LOADING', false);
            } catch (error) {
                console.log(error);
                commit('SET_SINGLE_BUSINESS_LOADING', false);
            }
        },


        async fetchCategories({commit}) {
            const url = `/api/categories`;
            try {
                let response = await axios.get(url)
                commit('SET_CATEGORIES_DATA', response.data)
            } catch (errors) {
                console.log(errors)
            }
        },

        async fetchSubCategories({commit}, category_id) {
            const url = `/api/categories/${category_id}/subcategories`;

            try {
                let response = await axios.get(url);
                commit('SET_SUBCATEGORIES_DATA', response.data);
                console.log('sub catgeoryr', response.data)
            } catch (error) {
                console.log(error);
            }
        },
        setSelectedCategory({commit}, categoryId) {
            commit('SET_SELECTED_CATEGORY', categoryId);
        },

        async fetchAddBusinessCountry({ commit }) {
            commit('SET_COUNTRY_LOADING', true);
            const url = `/api/country`;
            try {
                let response = await axios.get(url);
                const transformedData = response.data.map(country => ({
                    id: country.id,
                    text: country.name,
                    slug: country.slug
                }));
                commit('SET_COUNTRY_DATA', transformedData);
            } catch (errors) {
                console.log(errors);
            } finally {
                commit('SET_COUNTRY_LOADING', false);
            }
        },

        async fetchBusinessGallery({commit}, id) {
            const url = `/api/BusinessDetailGallery/${id}`;
            try {
                commit('SET_GALLERY_DATA_LOADING', true)
                let response = await axios.get(url);
                commit('SET_GALLERY_DATA', response.data);
                commit('SET_GALLERY_DATA_LOADING', false)
            } catch (errors) {
                console.log(errors);
                commit('SET_GALLERY_DATA_LOADING', false)
            }
        },

        async fetchBusinessProductSearch({commit}, payload) {
            const url = `https://admin.420finder.net/api/business-products/search`;
            const {business_type, business_id, page_number, search} = payload;
            try {
                commit('SET_PRODUCT_LOADING', true);
                const response = await axios.post(url, payload);
                // console.log('Search Response:', response.data);
                commit('SET_PRODUCT_DATA', response.data);
            } catch (error) {
                console.error('Search Error:', error);
            } finally {
                commit('SET_PRODUCT_LOADING', false);
            }
        },

        async fetchAllProducts({ commit }, payload) {
            const { business_id, page_number, category_id, price_min, price_max ,isfeatured ,isStock } = payload;

            let url = `/api/products/${business_id}?page=${page_number}`;

            if (category_id) {
                url += `&category_id=${category_id}`;
            }

            // 🔥 Fix: Ensure price filtering is applied correctly
            if (price_min !== null && price_max !== null) {
                url += `&price_min=${price_min}&price_max=${price_max}`;
            }

            if (isfeatured){
                url += `&isfeatured=${isfeatured}`;
            }

            if (isStock){
                url+= `&isStock=${isStock}`;
            }

            try {
                commit('SET_PRODUCT_SHIMMER', true);
                let response = await axios.get(url);
                commit('SET_PRODUCT_DATA', response.data.data);
                commit('SET_PAGINATION', response.data);
            } catch (errors) {
                console.log(errors);
            } finally {
                commit('SET_PRODUCT_SHIMMER', false);
            }
        },

        // Other actions...


        async fetchBusinessReview({commit}, payload) {
            const {business_id, page_number} = payload;
            const url = `/api/BusinessDetailReview/${business_id}?page=${page_number}`;
            try {
                commit('SET_BUSINESS_REVIEW_LOADER' , true);
                let response = await axios.get(url);
                commit('SET_REVIEW_DATA', response.data.data);
                commit('SET_PAGINATION', response.data);
                commit('SET_BUSINESS_REVIEW_LOADER' , false);

            } catch (errors) {
                console.log(errors);
            }
        },

        async fetchAllProductCategories({commit}, id) {
            const url = `/api/productCategory/${id}`;
            try {
                let response = await axios.get(url);
                commit('SET_PRODUCT_CATEGORY_DATA', response.data);
            } catch (errors) {
                console.log(errors);
            }
        },


        incrementProductQuantity({commit}, index) {
            commit('INCREMENT_PRODUCT_QUANTITY', index);
        },
        decrementProductQuantity({commit}, index) {
            commit('DECREMENT_PRODUCT_QUANTITY', index);
        },
        async incrementQuantityFromCart({commit, state, dispatch}, index) {
            commit('INCREMENT_PRODUCT_QUANTITY_FROM_CART', index);
            const item = state.cartItems.items[index];
            try {
                await axios.post('/api/update-cart', {
                    product_id: item.id,
                    quantity: item.quantity,
                });
                dispatch('fetchCartItems');
            } catch (error) {
                console.error('Error updating cart:', error);
                commit('DECREMENT_PRODUCT_QUANTITY_FROM_CART', index);
            }
        },

        async decrementQuantityFromCart({commit, state, dispatch}, index) {
            commit('DECREMENT_PRODUCT_QUANTITY_FROM_CART', index);
            const item = state.cartItems.items[index];
            try {
                await axios.post('/api/update-cart', {
                    product_id: item.id,
                    quantity: item.quantity,
                });
                dispatch('fetchCartItems');
            } catch (error) {
                console.error('Error updating cart:', error);
                commit('INCREMENT_PRODUCT_QUANTITY_FROM_CART', index);
            }
        },


        async removeItemFromCart({commit, state, dispatch}, product_id) {
            try {
                await axios.post('/api/remove-cart', {
                    product_id: product_id,
                });
                if (state.cartItems.count === 1) {
                    localStorage.removeItem('cart_business_id');
                   setTimeout(() => {
                       router.push('/');  // This should now work
                   } ,1000)
                }
                dispatch('fetchCartItems');

            } catch (error) {
                console.error('Error removing cart:', error);
            } finally {
                toast.success('Item Removed From Cart Successfully!');
            }
        },
        incrementSingleProductQuantity({commit}) {
            commit('INCREMENT_SINGLE_PRODUCT_QUANTITY');
        },
        decrementSingleProductQuantity({commit}) {
            commit('DECREMENT_SINGLE_PRODUCT_QUANTITY');
        },

        async addToCartState({commit, state, dispatch}, payload) {
            try {
                let cart_business_id = localStorage.getItem('cart_business_id');
                console.log(cart_business_id);
                const product = state.products[payload.index];
                console.log(product);

                if (!cart_business_id) {
                    cart_business_id = product.business_id;
                    localStorage.setItem('cart_business_id', cart_business_id);

                }

                if (product && cart_business_id == product.business_id) {
                    commit('SET_ADD_TO_CART_BUTTON_LOADING', true);

                    // Ensure payload structure matches the backend expectations
                    let response = await axios.post('/api/add-to-cart', {
                        'product': product, // Check if 'product' key is expected by your backend
                        'quantity': payload.quantity,
                        'color' : payload.selectedColor,
                        'size' : payload.selectedSize
                    });

                    dispatch('fetchCartItems');
                    commit('SET_ADD_TO_CART_BUTTON_LOADING', false);
                    toast.success('Item Added In Cart Successfully!');
                } else {
                    if (!product) {
                        toast.error('Invalid product');
                    } else {
                        const errorMessage = 'You already have items in the cart from a different business. ' +
                            'Please clear your cart before making another purchase.';
                        toast.error(errorMessage);
                    }
                }
            } catch (error) {
                console.error(error);
                commit('SET_ADD_TO_CART_BUTTON_LOADING', false);
            }
        },

        async fetchCartItems({commit, state}) {
            try {
                let response = await axios.get('/api/cart-items');
                commit('SET_CART_ITEMS', response.data)
                // console.log()
            } catch (error) {
                console.error(error);
            }
        },

        async clearCompleteCart({commit, state, dispatch}) {
            await axios.get('/api/cart-clear');
            commit('SET_CART_ITEMS', null);
            localStorage.removeItem('cart_business_id');
            localStorage.removeItem('deal_business_id');
        },


        async addToCartFromSingleProduct({commit, state, dispatch}, payload) {
            try {
                let cart_business_id = localStorage.getItem('cart_business_id');
                const product = state.singleProduct; // Get the product from state
                if (!cart_business_id) {
                    cart_business_id = product.business_id;
                    localStorage.setItem('cart_business_id', cart_business_id);
                }
                if (product && cart_business_id == product.business_id) {
                    commit('SET_ADD_TO_CART_BUTTON_LOADING', true);
                    let response = await axios.post('/api/add-to-cart', {
                        'product': product,
                        'quantity': payload.quantity
                    });
                    dispatch('fetchCartItems');
                    commit('SET_ADD_TO_CART_BUTTON_LOADING', false);
                    toast.success('Item Added In Cart Successfully!');
                } else {
                    if (!product) {
                        toast.error('Invalid product');
                    } else {
                        const errorMessage = 'You already have items in the cart from a different business. ' +
                            'Please clear your cart before making another purchase.';
                        toast.error(errorMessage);
                    }
                }
            } catch (error) {
                console.error(error);
                commit('SET_ADD_TO_CART_BUTTON_LOADING', false);
            }
        },


        //    christopher all businesses

        async fetchAllBusiness({commit}, payload) {
            const {categoryId, subCategoryId, page_number} = payload;
            console.log('payloa of business', payload)
            let url = `/api/businesses/${categoryId}/${subCategoryId}?page=${page_number}`

            try {
                commit('SET_BUSINESS_LOADING', true)
                let response = await axios.get(url);
                commit('SET_BUSINESS', response.data.data)
                commit('SET_PRODUCT_TOTAL_RESULT', response.data.meta.total);
                commit('SET_PAGINATION', response.data.meta);
                console.log('response.data.meta', response.data.meta)
                commit('SET_BUSINESS_LOADING', false)
            } catch (error) {
                console.log('error', error)
                commit('SET_BUSINESS_LOADING', false)
            }
        },

        async fetchSubCategory({commit}, categoryId) {
            let url = `/api/subcategories/${categoryId}`

            try {
                commit('SET_SUBCATEGORY_LOADING', true)
                let response = await axios.get(url);
                commit('SET_SUBCATEGORY', response.data)
                commit('SET_SUBCATEGORY_LOADING', false)
            } catch (error) {
                console.log('error', error)
                commit('SET_SUBCATEGORY_LOADING', false)
            }
        },


        async fetchCity({commit}, city){

            let url = `/api/city/${city}`;

            try{
                commit('SET_CITY_LOADING', true)
                let response = await axios.get(url);
                commit('SET_CITY', response.data.data);
                console.log('SETCITY' ,response.data.data);
                commit('SET_CITY_LOADING', false)
            }catch(error){
                console.log('error', error)
                commit('SET_CITY_LOADING', false)
            }
        },

    //     apply coupon
    },
};

export default businessModule;
